export default {
  "accountPayableManagement.filmFeeRegistration": "フィルム料（買掛金）登録/編集",
  "accountPayableManagement.accountsPayableDetails": "買掛金明細名",
  "accountPayableManagement.requestDate": "請求締日",
  "accountPayableManagement.paymentDueDate": "支払予定日",
  "accountPayableManagement.recordedAmount/invoiceAmount": "計上金額/請求書記載金額",
  "accountPayableManagement.filmFeeDetails": "フィルム料明細",
  "accountPayableManagement.targetTheaters": "対象劇場（複数選択可）",
  "accountPayableManagement.targetBusinessPartners": "対象取引先（複数選択可）",
  "accountPayableManagement.accountsPayableDetails.placeholder": "買掛金明細名を入力してください",
  "accountPayableManagement.recordedAmount/invoiceAmount.placeholder": "計上金額を入力してください",
  "accountPayableManagement.targetTheaters.placeholder": "対象劇場を選択してください",
  "accountPayableManagement.targetBusinessPartners.placeholder": "対象取引先を選択してください",
  "accountPayableManagement.filmChargeExtractionPeriod": "フィルム料抽出対象期間",
  "accountPayableManagement.drawOut": "抽出",
  "accountPayableManagement.theaterName": "劇場名",
  "accountPayableManagement.customerName": "取引先名",
  "accountPayableManagement.targetPeriod": "対象期間",
  "accountPayableManagement.income": "興行収入",
  "accountPayableManagement.mobilization": "動員",
  "accountPayableManagement.filmFee": "フィルム料",
  "accountPayableManagement.calculateTheAmount": "計上金額",
  "accountPayableManagement.theTotalAmountOfTheCompleteCollection": "全集計明細合計額",
  "accountPayableManagement.totalAmountOfSelectionItems": "選択明細の合計額",
  "accountPayableManagement.differenceFromTheAmountStatedOnTheInvoice": "請求書記載金額との差額",
  "accPayM.nameMsg": "買掛金明細名が必要です",
  "accPayM.amount": "計上金額/請求書記載金額が必要です",
  "accPayM.theater": "対象劇場が必要です",
  "accPayM.client": "対象取引先が必要です",
  "accPayMDetail.filmFeeDetails": "フィルム料明細 登録/編集",
  "accPayMDetail.filmRate": "フィルム料歩率",
  "accPayMDetail.requestAmount": "請求金額",
  "accPayMDetail.difference": "差額",
  "accPayMDetail.mainBusiness": "本興行",
  "accPayMDetail.morningShow": "モーニングショー",
  "accPayMDetail.lateShow": "レイトショー",
  "accPayMDetail.allNight": "オールナイト",
  "accPayMDetail.specialBusiness": "特別興行",
  "accPayMDetail.total": "合計",
  "accPayM.errText1": "対象劇場を選択してください",
  "accPayM.errText2": "対象取引先を入力してください",

  "purchase.title": "買取仕入（買掛金）登録/編集",
  "proxy.title": "委託仕入（買掛金）登録/編集",
  "purchase.detail": "買取仕入明細",
  "proxy.detail": "委託仕入明細",
  "otherPurchase.detail": "その他仕入明細",
  "purchase.productName": "商品名",
  "purchase.arrival/returnAmount": "入荷/返送金額",
  "proxy.returnAmount": "売上原価",
  "purchase.arrivalAmount": "入荷金額",
  "purchase.detailed/summary": "詳細/摘要",
  "purchase.totalAmountOfProductionDetails": "全作成明細合計額",
  "purchaseExtractionTargetPeriod": "買取仕入抽出対象期間",
  "proxy.period": "委託仕入抽出対象期間",
  "purchase": "買取仕入",
  "proxy": "委託仕入",
  "purchase.logID": "ログID",
  "purchase.logDate": "日時",
  "purchase.inventoryChangeType": "種類",
  "purchase.stockChangeQty": "変動数",
  "purchase.stockChangeAmount": "変動金額",
  "proxy.productSales": "商品売上",
  "proxy.purchasePrice": "仕入価格(単価)",
  "proxy.number": "販売数",
};